//InfluenceurService.jsx
import { base_url } from "./ClientService"; // si tu as déjà défini base_url

// 🔹 Connexion Influenceur
export async function loginInfluenceur(email, password) {
    try {
        const response = await fetch(`${base_url}influenceurs/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password }),
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
            return { success: false, message: data.message || "Échec de la connexion." };
        }

        return { success: true, token: data.token, influenceur: data.influenceur };
    } catch (err) {
        return { success: false, message: err.message || "Erreur inattendue" };
    }
}

// 🔹 Inscription Influenceur
export async function registerInfluenceur(nom_complet, email, password) {
    try {
        const response = await fetch(`${base_url}influenceurs/register`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ nom_complet, email, password }),
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
            return { success: false, message: data.message || "Erreur lors de l'inscription." };
        }

        return { success: true, token: data.token, influenceur: data.influenceur };
    } catch (err) {
        return { success: false, message: err.message || "Erreur inattendue" };
    }
}

// 🔹 Récupérer influenceur connecté
export async function getMe(token = null) {
    if (!token) token = localStorage.getItem("authTokenInfluenceur");
    if (!token) throw new Error("Utilisateur non authentifié");

    try {
        const response = await fetch(`${base_url}influenceurs/me`, {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        if (!response.ok || !data.success) throw new Error(data.message || "Erreur lors de la récupération du profil");
        return data.influenceur;
    } catch (err) {
        console.error(err);
        return null;
    }
}

// 🔹 Déconnexion influenceur
export async function logoutInfluenceur(token = null) {
    if (!token) token = localStorage.getItem("authTokenInfluenceur");
    if (!token) throw new Error("Utilisateur non authentifié");

    const response = await fetch(`${base_url}influenceurs/logout`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    return data;
}

// 🔹 Rafraîchir token JWT
export async function refreshToken(token = null) {
    if (!token) token = localStorage.getItem("authTokenInfluenceur");
    if (!token) throw new Error("Utilisateur non authentifié");

    const response = await fetch(`${base_url}influenceurs/refresh`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    return data;
}

// 🔹 Mettre à jour le profil
export async function updateProfilInfluenceur(profilData) {
    const token = localStorage.getItem("authTokenInfluenceur");
    if (!token) throw new Error("Utilisateur non authentifié");

    const response = await fetch(`${base_url}influenceurs/profil`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(profilData),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "Erreur lors de la mise à jour du profil");
    return data.influenceur;
}

// 🔹 Mettre à jour RIB
export async function updateRibInfluenceur(rib) {
    const token = localStorage.getItem("authTokenInfluenceur");
    if (!token) throw new Error("Utilisateur non authentifié");

    const response = await fetch(`${base_url}influenceurs/rib`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ rib }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "Erreur lors de la mise à jour du RIB");
    return data.rib;
}

// 🔹 Mettre à jour mot de passe
export async function updatePasswordInfluenceur(ancienPassword, newPassword) {
    const token = localStorage.getItem("authTokenInfluenceur");
    if (!token) throw new Error("Utilisateur non authentifié");

    const response = await fetch(`${base_url}influenceurs/password`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ancienPassword, newPassword }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "Erreur lors de la mise à jour du mot de passe");
    return data.message;
}

// 🔹 Dashboard influenceur
export async function getDashboardInfluenceur() {
    const token = localStorage.getItem("authTokenInfluenceur");

    if (!token) {
        // Gestion du token manquant
        return {
            success: false,
            message: "Utilisateur non authentifié",
            stats: {
                clics: 0,
                inscriptions: 0,
                abonnes: 0,
                commissions: "0,00",
            },
            chartData: [],
        };
    }

    try {
        const response = await fetch(`${base_url}influenceurs/dashboard`, {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
            // Retour par défaut en cas d'erreur API
            return {
                success: false,
                message: data.message || "Erreur lors de la récupération du dashboard",
                stats: {
                    clics: 0,
                    inscriptions: 0,
                    abonnes: 0,
                    commissions: "0,00",
                },
                chartData: [],
            };
        }

        // Retour normal
        return {
            success: true,
            stats: {
                clics: data.stats?.clics || 0,
                inscriptions: data.stats?.inscriptions || 0,
                abonnes: data.stats?.abonnes || 0,
                commissions: data.stats?.commissions || "0,00",
            },
            chartData: data.chartData || [],
        };

    } catch (err) {
        // Gestion des erreurs réseau ou JSON invalide
        console.error("Erreur getDashboardInfluenceur:", err);
        return {
            success: false,
            message: err.message || "Erreur inattendue",
            stats: {
                clics: 0,
                inscriptions: 0,
                abonnes: 0,
                commissions: "0,00",
            },
            chartData: [],
        };
    }
}

// 🔹 Liste des clients influenceur (avec pagination)
export async function getClientsInfluenceur(page = 1, per_page = 10) {
    const token = localStorage.getItem("authTokenInfluenceur");
    if (!token) throw new Error("Utilisateur non authentifié");

    const response = await fetch(`${base_url}influenceurs/clients?page=${page}&per_page=${per_page}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
    });

    const data = await response.json();
    if (!response.ok || !data.success) throw new Error(data.message || "Erreur lors de la récupération des clients");
    return data;
}

// 🔹 Liste des commissions
export async function getCommissionsInfluenceur(page = 1, per_page = 10) {
    const token = localStorage.getItem("authTokenInfluenceur");
    if (!token) throw new Error("Utilisateur non authentifié");

    const response = await fetch(`${base_url}influenceurs/commissions?page=${page}&per_page=${per_page}`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
    });

    const data = await response.json();
    if (!response.ok || !data.success) throw new Error(data.message || "Erreur lors de la récupération des commissions");
    return data;
}
